import { FlowStepEditor } from "../FlowStepEditor";
import React from "react";
import { RunValueTable } from "../../../rule-engine-core/Flow/Steps/Rules/RunValueTable";
// import { StyledButton } from "../../../CommonUI/Components/Button";
// import { Layer } from "../../../CommonUI/Components/Layer";
// import { ValueTableRuleBuilder } from "../../../Rule/Table/ValueTable/ValueTableRuleBuilder";
// import { StateManager } from "../../../Common/Common/StateManager";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StepEditUI = ({ step }: { step: RunValueTable }) => {
    //    const [open, setOpen] = React.useState<boolean>(false);

    return (
        <></>

        // <>
        //         <StyledButton sx={{color:UIStyleConstants.BLUE_COLOR}} variant="contained" onClick={() => setOpen(true)}>
        //             Edit {step.name || "Rule Step"}
        //         </StyledButton>
        //
        //         <UILayer
        //             open={open}
        //             maxWidth={false}
        //             fullScreen
        //             padding="0px 0px"
        //             renderUI={() => (
        //                 <ValueTableRuleBuilder
        //                     ruleDefinition={step.executable}
        //                     title={step.executable.title || step.name}
        //                     onRuleCancel={() => {
        //                         setOpen(false);
        //                     }}
        //                     onRuleSave={() => {
        //                         StateManager.changed(step);
        //                         setOpen(false);
        //                     }}
        //                 />
        //             )}
        //             onClose={() => setOpen(false)}
        //         />
        //     </>
    );
};

export class RunValueTableEditor extends FlowStepEditor<RunValueTable> {
    renderEditUI(): JSX.Element | null {
        return <StepEditUI step={this.stepData} />;
    }
}
